var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 11.9201C26.6527 11.7976 26.6259 11.6769 26.5866 11.5601V11.4401C26.5225 11.303 26.437 11.177 26.3333 11.0667V11.0667L18.3333 3.06675C18.223 2.96304 18.097 2.87752 17.9599 2.81341H17.8399L17.4133 2.66675H9.33325C8.27239 2.66675 7.25497 3.08818 6.50482 3.83832C5.75468 4.58847 5.33325 5.60588 5.33325 6.66675V25.3334C5.33325 26.3943 5.75468 27.4117 6.50482 28.1618C7.25497 28.912 8.27239 29.3334 9.33325 29.3334H22.6666C23.7275 29.3334 24.7449 28.912 25.495 28.1618C26.2452 27.4117 26.6666 26.3943 26.6666 25.3334V12.0001C26.6666 12.0001 26.6666 12.0001 26.6666 11.9201ZM18.6666 7.21341L22.1199 10.6667H18.6666V7.21341ZM23.9999 25.3334C23.9999 25.687 23.8594 26.0262 23.6094 26.2762C23.3593 26.5263 23.0202 26.6667 22.6666 26.6667H9.33325C8.97963 26.6667 8.64049 26.5263 8.39044 26.2762C8.14039 26.0262 7.99992 25.687 7.99992 25.3334V6.66675C7.99992 6.31313 8.14039 5.97399 8.39044 5.72394C8.64049 5.47389 8.97963 5.33341 9.33325 5.33341H15.9999V12.0001C15.9999 12.3537 16.1404 12.6928 16.3904 12.9429C16.6405 13.1929 16.9796 13.3334 17.3333 13.3334H23.9999V25.3334Z",
    fill: "#5F5FFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.793a52239d80bdded94b1ba880c4267a.svg";
export { ForwardRef as ReactComponent };